module.exports = __webpack_public_path__ + "static/img/7.6ce2ef1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/12/zh/7.png
// module id = KquB
// module chunks = 0